import { getImageMetadata } from '../components/fixers/alt-image-fixer/hooks/image-size/image-size';
import { originalImageUrl, resolveImageUrl } from './resolve-image-url';
import { withTimeout } from './with-timeout';
const TIMEOUT_MS = 2000;
const MAX_HEIGHT = 150;
const MAX_WIDTH = 226;
export const resizeImageUrl = async uri => {
  let height = 300;
  let width = 300;
  try {
    const {
      dimensions
    } = await withTimeout(getImageMetadata(originalImageUrl(uri)), TIMEOUT_MS);
    height = (dimensions == null ? void 0 : dimensions.height) ?? height;
    width = (dimensions == null ? void 0 : dimensions.width) ?? width;
  } catch (error) {
    console.warn(`Failed to get image metadata for ${uri}, using default ${width}px x ${height}px dimensions`, error);
  }
  const scaleFactor = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
  const resizedWidth = Math.round(width * scaleFactor);
  const resizedHeight = Math.round(height * scaleFactor);
  return resolveImageUrl(uri, resizedWidth, resizedHeight);
};
//# sourceMappingURL=resize-image-url.js.map